export default function extendPopulation(arrayTo, arrayFrom) {
  const extended = arrayTo.map((country) => {
    let copyCountry = { ...country };
    const objFrom = arrayFrom.find((item) => item.countryInfo.iso2 === country.CountryCode);
    if (objFrom === undefined) {
      copyCountry = {
        ...copyCountry,
        population: 100000,
      };
    } else {
      copyCountry = {
        ...copyCountry,
        ...objFrom,
        TotalRecovered: objFrom.recovered,
      };
    }
    return copyCountry;
  });
  return extended;
}
